import { useQueryParams } from "@/hooks/use-query-params"

export function useAddBrokerIdToLink() {
  const queryParams = useQueryParams()
  const brokerId = queryParams.brokerId

  /**
   * Adds the current brokerId to a URL if it exists in query params
   * @param url The URL or path to add the brokerId to
   * @returns The URL with brokerId parameter added if available
   */
  const addBrokerIdToUrl = (url: string): string => {
    if (!brokerId) return url

    const separator = url.includes("?") ? "&" : "?"
    return `${url}${separator}brokerId=${brokerId}`
  }

  return { addBrokerIdToUrl, brokerId }
}
